import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

export const FieldRow = styled.div`
	display: flex;
	align-items: flex-start;
	column-gap: 12px;

	${mobileMediaQuery(css`
		flex-direction: column;
	`)}
`
